export default {
  //存储数据
  state: {
    isCollapse: false,
    currentMenu: null,
    tabsList: [
      {
        path: "home",
        name: "home",
        meta: {
          title: "首页"
        },
        icon: "home"
      }
    ]
  },
  //调用方法
  mutations: {
    collapseMenu(state) {
      state.isCollapse = !state.isCollapse;
    },
    //选择标签 选择面包屑
    selectMenu(state, val) {
      if (val.name === "home") {
        state.currentMenu = null;
      } else {
        state.currentMenu = val;
        //如果等于-1说明tabsList不存在那么插入，否则什么都不做
          console.log(state.tabsList)
          if(state.tabsList.map(item => item.name).indexOf(val.name) === -1){
              state.tabsList.push(val)
          }
      }
      // val.name === 'home' ? (state.currentMenu = null) : (state.currentMenu = val)
    },
    //关闭标签
    closeTab(state, val) {
      let result = state.tabsList.findIndex(item => item.name === val.name);
      state.tabsList.splice(result, 1);
    },
    //删除数据，用于退出按钮
    remove(state, val) {
      state.tabsList = val;
    }
  },
  actions: {}
};
